import React, { useEffect } from 'react';
import { setTitle } from '../utils/environment';

const Privacy = () => {
  useEffect(() => setTitle('Privacy Policy'), []);

  const effectiveDate = '2025-08-11';

  return (
    <div className="min-h-screen bg-clay-bg py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto card-clay p-8 md:p-10">
        <h1 className="font-display text-3xl font-bold text-heading mb-2">Privacy Policy</h1>
        <p className="text-sm text-secondary-text mb-8">Effective date: {effectiveDate}</p>

        <div className="prose prose-gray max-w-none prose-headings:font-display prose-a:text-primary-600 prose-a:hover:text-primary-500">
          <p>
            This Privacy Policy explains how Read It Never (&quot;we&quot;, &quot;us&quot;) collects, uses, and shares information when you
            use our Service.
          </p>

          <h2>1. Information We Collect</h2>
          <ul>
            <li>Account data: email and authentication information.</li>
            <li>Content you submit: article URLs, extracted content, and summaries.</li>
            <li>Usage data: app interactions, device information, and diagnostics.</li>
          </ul>

          <h2>2. How We Use Information</h2>
          <ul>
            <li>Provide and improve the Service and its features.</li>
            <li>Generate AI summaries from your submitted content.</li>
            <li>Protect against misuse and ensure reliability.</li>
            <li>Communicate with you about updates and support.</li>
          </ul>

          <h2>3. Sharing</h2>
          <p>
            We do not sell your personal information. We may share data with service providers (e.g., hosting, AI
            providers) under appropriate agreements, and when required by law.
          </p>

          <h2>4. Data Retention</h2>
          <p>
            We retain information as long as necessary to provide the Service and comply with legal obligations. You may
            request deletion of your data subject to limitations.
          </p>

          <h2>5. Security</h2>
          <p>
            We use reasonable safeguards to protect data. No method of transmission or storage is 100% secure.
          </p>

          <h2>6. Your Choices</h2>
          <ul>
            <li>Access, update, or delete your account data.</li>
            <li>Opt out of non-essential communications.</li>
          </ul>

          <h2>7. International Transfers</h2>
          <p>
            Your data may be processed in regions where we or our providers operate. We take steps to ensure adequate
            protections.
          </p>

          <h2>8. Children</h2>
          <p>The Service is not intended for children under 13.</p>

          <h2>9. Changes</h2>
          <p>
            We may update this Privacy Policy from time to time. Material changes will be announced via the Service.
          </p>

          <h2>10. Contact</h2>
          <p>
            Questions? Contact us at <a href="mailto:privacy@readitnever.xyz">privacy@readitnever.xyz</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;


